import { render, staticRenderFns } from "./HobbyShop.vue?vue&type=template&id=8c28a5aa&scoped=true&"
import script from "./HobbyShop.vue?vue&type=script&lang=js&"
export * from "./HobbyShop.vue?vue&type=script&lang=js&"
import style0 from "./HobbyShop.vue?vue&type=style&index=0&id=8c28a5aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c28a5aa",
  null
  
)

export default component.exports